// Generated from onedeskFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by onedeskFormula.

export default class onedeskFormulaVisitor extends antlr4.tree.ParseTreeVisitor {

	// Visit a parse tree produced by onedeskFormula#root.
	visitRoot(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#FieldReference.
	visitFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#StringLiteral.
	visitStringLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#Brackets.
	visitBrackets(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#BooleanLiteral.
	visitBooleanLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#RightWhitespaceOrComments.
	visitRightWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#DecimalLiteral.
	visitDecimalLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#LeftWhitespaceOrComments.
	visitLeftWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#FunctionCall.
	visitFunctionCall(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#FieldByIdReference.
	visitFieldByIdReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#LookupFieldReference.
	visitLookupFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#IntegerLiteral.
	visitIntegerLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#BinaryOp.
	visitBinaryOp(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#ws_or_comment.
	visitWs_or_comment(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#func_name.
	visitFunc_name(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#field_reference.
	visitField_reference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by onedeskFormula#identifier.
	visitIdentifier(ctx) {
	  return this.visitChildren(ctx);
	}



}